import React from "react";
import { RideSkeleton } from "@rimac-seguros/ride-system-components";
import { CustomSliderRange } from "@/components/molecules/CustomSliderRange";
import {
  RideGlInformationSolid,
  RideInformativePopover,
} from "@rimac-seguros/ride-system-components";

export const CreditTermSetting = ({
  list,
  defaultValue,
  loading,
  onSelected,
  isGreatterValue,
}) => {
  return (
    <>
      <div className="relative border-b py-ride-gl-spacing-4xlarge border-ride-sys-color-border-default">
        <h2 className="ride-sys-text-title-xlarge-default mb-ride-gl-spacing-2xlarge gap-ride-gl-spacing-large lg:ride-sys-text-title-2xlarge-default lg:mb-ride-gl-spacing-4xlarge">
          Elige un plazo que sea mayor o igual a los años restantes de tu
          crédito
          <RideInformativePopover
            glyph={<RideGlInformationSolid />}
            aria-label="Plazos de cobertura"
            className="absolute ml-1"
            isNonModal
            size="medium"
            position="top-start"
            title="Revisa el plazo restante de tu deuda"
            paragraph="Elegir un tiempo menor impedirá que puedas endosarlo"
          />
        </h2>
        <div>
          {!loading && list?.length > 0 ? (
            <CustomSliderRange
              list={list}
              defaultValue={defaultValue}
              defaultTextToSelected="años"
              onSelect={onSelected}
              isGreatterValue={isGreatterValue}
            />
          ) : (
            <RideSkeleton type="rectangle" height={48} width="100%" />
          )}
        </div>
      </div>
    </>
  );
};
